import React from "react";
import { Input } from "antd";

// ==================== 类型定义 ====================

interface SupplierSelectInputProps {
  value?: string;
  onChange?: (value: string) => void;
  onOpenModal?: () => void;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

// ==================== 主组件 ====================

/**
 * 供应商选择输入框组件
 * 显示已选择的供应商，点击时打开弹窗选择
 * 在查看模式（disabled=true）下禁止点击打开弹窗
 */
const SupplierSelectInput: React.FC<SupplierSelectInputProps> = ({
  value,
  onChange,
  onOpenModal,
  readOnly = true,
  disabled = false,
  placeholder = "请选择供应商",
}) => {
  const handleClick = () => {
    // 在禁用模式下不执行打开弹窗操作
    if (!disabled) {
      onOpenModal?.();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <Input
        value={value || ""}
        placeholder={placeholder}
        readOnly={readOnly || disabled}
        disabled={disabled}
        onClick={handleClick}
        onChange={handleChange}
        style={{
          flex: 1,
          cursor: readOnly || disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
        }}
      />
    </div>
  );
};

export default SupplierSelectInput;
